<!-- @format -->

<template>
    <div class="gst-event-sidebar__footer">
        <EventTotalsContainer
            :title="title"
            :event="event"
            :bundle-products="bundleProducts" />
    </div>
</template>

<script>
import EventTotalsContainer from '../EventTotalsContainer.vue';

export default {
    name: 'EventSidebarFooter',
    components: {
        EventTotalsContainer,
    },
    props: {
        title: {
            type: String,
            default: null,
        },
        bundleProducts: {
            type: Object,
            default: null,
        },
        event: {
            type: Object,
            required: true,
        },
    },
};
</script>
